<template>
    <bank-cards-get
        :params="{
            with_unverified: false
        }"
        v-slot="{
            data: cards,
            meta,
            is_loading
        }"
        @success="onSuccess"
    >
        <div
            v-if="is_loading"
            class="opacity-50 input is-disabled"
        >
            <div class="py-px leading-none">
                Loading...
            </div>
        </div>

        <router-link
            v-else-if="meta.count === 0"
            class="btn btn-blue-lightest"
            :to="{
                name: $router.fix('dashboard.*.bank-cards.create')
            }"
        >
            Add a bank card
        </router-link>

        <input-select
            v-else
            :value="value"
            :sid="sid"
            :name="name"
            :disabled="disabled"
            :options="transform(cards)"
            placeholder="Select a bank card..."
            @input="$emit('input', arguments[0])"
        />
    </bank-cards-get>
</template>

<script>
    import _ from 'lodash'
    import BankCardsGet from './bank-cards-get'

    export default {
        components: {
            BankCardsGet
        },
        props: {
            value: {
                validator: value => true,
                required: true
            },
            uuid: {
                type: String,
                default: null
            },
            sid: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            transform (cards) {
                return _.map(cards, card => {
                    return {
                        value: this.valueify(card),
                        label: '**** **** **** ' + card.last_four,
                        sublabel: _.toUpper(card.brand)
                    }
                })
            },
            onSuccess ({ data: cards, meta }) {
                const card = _.first(cards, { is_default: true })

                if (card) {
                    this.$emit('input', this.valueify(card))
                }
            },
            valueify (card) {
                return {
                    object: card.object,
                    uuid: card.uuid
                }
            }
        }
    }
</script>
